import { createContext, useContext } from 'react'

export type AuthValues = {
  realm?: string
  email?: string
}

export type AuthContextType = {
  token: string | null
  setToken: (token: string | null) => void
  user: string | null
  userId: string | null
  onLogin: (
    values: AuthValues,
    onSuccess: () => void,
    onError: (error: string) => void
  ) => Promise<boolean>
  onRegister: (
    values: AuthValues,
    onSuccess: () => void,
    onError: (error: string) => void
  ) => Promise<boolean>
  onRequestNewPassword: (
    values: AuthValues,
    onSuccess: () => void,
    onError: (error: string) => void
  ) => Promise<boolean>
  onConfirmEmail: (
    values: AuthValues,
    onSuccess: () => void,
    onError: (error: string) => void
  ) => Promise<boolean>
  onResendCode: (
    values: AuthValues,
    onSuccess: () => void,
    onError: (error: string) => void
  ) => Promise<boolean>
  onCheckStatus: (
    onSuccess: () => void,
    onError: () => void
  ) => Promise<boolean>
  onLogout: () => void
  emailVerificationNeeded: (statusMsg: string) => boolean
  getUserNames: () => { firstName: string; lastName: string }
  apiHost?: string
}

// creating a context with an undefined default value and then checking for that undefined value in the hook.
export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
